export default "__VITE_ASSET__CWuCCo$e__"